import {EMetaActionType} from 'entities/metadata';

export const SIGNS_INCORRECT = 'Файлы подписи не верны';

interface IConfirmContentData {
    [key: string]: string;
}
export const ConfirmContent: IConfirmContentData = {
    [EMetaActionType.BUTTON_SAVE_FORM_PERSONAL_ACCOUNT]:
        'Требуется подтвердить изменения',
    [EMetaActionType.BUTTON_SEND_FOR_APPROVAL_REQUEST]:
        'Вы действительно хотите отправить запрос?',
};
